import createRoute from '@widesk-ui/tools/createRoute';
import TagModel    from '@models/shop/TagModel';

export default createRoute.dashboard('/tags', 'shop', 'TagDashboard', TagModel.localize());